import React from 'react';
import '../../styles/common.css';
import styles from './ServerRules.module.css';
import Contacts from '../Contacts/Contacts';

const ServerRules = () => {
  const sections = [
    {
      id: 1,
      title: '1. Общие положения',
      items: [
        {
          number: '1.1',
          text: 'Настоящие правила обязательны для ознакомления и исполнения всеми участниками сервера.'
        },
        {
          number: '1.2',
          text: 'Администрация вправе корректировать и изменять данные правила без предварительного уведомления игроков.'
        },
        {
          number: '1.3',
          text: 'Незнание правил не освобождает от ответственности за их нарушение.'
        },
        {
          number: '1.4',
          text: 'В целях защиты алгоритмов безопасности сервера, администрация вправе не предоставлять технические логи и внутренние доказательства нарушений игрокам.'
        },
        {
          number: '1.5',
          text: 'Игра и участие на сервере автоматически означают полное согласие с данными правилами.'
        },
        {
          number: '1.6',
          text: 'Приобретение любых внутриигровых ценностей или статусов не освобождает игрока от соблюдения настоящих правил. В случае блокировки аккаунта за нарушения возврат средств за приобретенные услуги не производится в соответствии с Публичной офертой проекта.'
        }
      ]
    },
    {
      id: 2,
      title: '2. Компенсации и восстановление имущества',
      items: [
        {
          number: '2.1',
          text: 'Компенсация или восстановление предметов, внутриигрового прогресса и прочих ценностей возможны только в том случае, если они были утеряны из-за ошибок серверной части или багов в модификациях.'
        },
        {
          number: '2.2',
          text: 'Предметы и прогресс, утерянные по вине или ошибке самого игрока, компенсации не подлежат.'
        }
      ]
    },
    {
      id: 3,
      title: '3. Аккаунты и никнеймы игроков',
      items: [
        {
          number: '3.1',
          text: 'Владелец аккаунта несет полную ответственность за все действия, совершенные с его учетной записи. Авторизация на сервере происходит через официальные сервисы Hytale, передача данных аккаунта третьим лицам категорически запрещена. Оправдания в стиле «меня взломали» или «это играл брат/друг» не являются основанием для снятия блокировки.'
        },
        {
          number: '3.2',
          text: 'Никнейм игрока не должен содержать оскорбления, нецензурную лексику, провокационные фразы, а также имитировать никнеймы модераторов, администраторов или официальных стримеров проекта.'
        },
        {
          number: '',
          text: 'Наказание: Блокировка аккаунта с возможностью обжалования и снятия бана только после смены никнейма.'
        },
        {
          number: '',
          text: 'Отягчающее обстоятельство: За умышленную попытку выдать себя за администрацию в мошеннических целях выдается перманентный бан.'
        }
      ]
    },
    {
      id: 4,
      title: '4. Кланы и сообщества',
      items: [
        {
          number: '4.1',
          text: 'Названия кланов и сообществ не должны содержать оскорблений или фраз, унижающих других игроков или сторонние кланы.'
        },
        {
          number: '4.2',
          text: 'Запрещено использовать баги клановых механик для получения любых игровых преимуществ.'
        },
        {
          number: '',
          text: 'Наказание за п. 4.1 и 4.2: 2 варна. Повторное нарушение — бан на 24 часа.'
        },
        {
          number: '4.3',
          text: 'Кланам запрещено создавать более 2 под-кланов (структура: 1 основной клан + максимум 2 под-клана) с целью искусственного увеличения общего количества участников.'
        },
        {
          number: '',
          text: 'Наказание: 1 варн.'
        },
        {
          number: '4.4',
          text: 'Лидер клана несёт прямую ответственность за действия своих участников, если доказано, что руководство знало об использовании багов/читов или использовало полученные нечестным путем ресурсы.'
        },
        {
          number: '',
          text: 'Наказание: Блокировка причастных лиц, изъятие ресурсов, вплоть до принудительного расформирования клана.'
        }
      ]
    },
    {
      id: 5,
      title: '5. Территории и приваты (Чужие зоны)',
      items: [
        {
          number: '5.1',
          text: 'Игрокам разрешено посещать территории чужих приватов, если это не нарушает другие пункты настоящих правил.'
        },
        {
          number: '5.2',
          text: 'Владельцы и участники привата имеют право устанавливать внутренние правила на своей территории. Они вправе потребовать от любого постороннего игрока немедленно покинуть их приват.'
        },
        {
          number: '5.3',
          text: 'Запрещено игнорировать требования владельцев привата покинуть территорию, если нахождение игрока создает помехи их игровому процессу.'
        },
        {
          number: '5.4',
          text: 'Под помехой понимается: блокирование проходов, перекрывание обзора при строительстве, сбор выпадающего лута с чужих ферм/мобов, АФК на чужой территории, а также целенаправленное преследование.'
        },
        {
          number: '5.5',
          text: 'На сервере действует система автоматического снятия защиты с территорий неактивных игроков. Если владелец привата не заходит в игру более 21 дня, защита региона снимается. Постройки и сундуки со всем содержимым сохраняются, территория становится общедоступной — любой игрок может занять её и получить доступ к ресурсам. Для сохранения региона при долгом отсутствии обратитесь в техподдержку.'
        },
        {
          number: '',
          text: 'Наказание за нарушения п. 5.3 и 5.4: Кик с сервера / Варн. Повторное или намеренное вредительство — бан от 6 до 24 часов.'
        }
      ]
    },
    {
      id: 6,
      title: '6. Общение в текстовых каналах и чатах',
      items: [
        {
          number: '6.1',
          text: 'Запрещены оскорбления, травля, разжигание конфликтов, спам, флуд и многократное повторение однотипных сообщений.'
        },
        {
          number: '6.2',
          text: 'Запрещена реклама сторонних проектов, серверов и сайтов без предварительного разрешения администрации.'
        },
        {
          number: '6.3',
          text: 'Запрещена публикация персональных данных (своих или чужих) без согласия причастных лиц.'
        },
        {
          number: '6.4',
          text: 'Запрещено распространение контента 18+, шокирующих изображений и ссылок на вредоносные ресурсы.'
        },
        {
          number: '6.5',
          text: 'Для общения необходимо использовать соответствующие тематические каналы.'
        }
      ]
    },
    {
      id: 7,
      title: '7. Голосовые каналы',
      items: [
        {
          number: '7.1',
          text: 'Запрещено создавать шумовые помехи (включать громкую музыку, транслировать посторонние резкие звуки).'
        },
        {
          number: '7.2',
          text: 'Необходимо уважать очередь в разговоре и не перебивать собеседников.'
        },
        {
          number: '7.3',
          text: 'Запрещено использовать звуковые эффекты (чейнджеры) для травли или обмана игроков.'
        },
        {
          number: '7.4',
          text: 'В голосовых каналах с ограничением по возрасту (18+) обязательно соблюдение соответствующих моральных норм.'
        }
      ]
    },
    {
      id: 8,
      title: '8. Контент и медиа',
      items: [
        {
          number: '8.1',
          text: 'Все загружаемые изображения и видео должны соответствовать тематике сервера и правилам площадок.'
        },
        {
          number: '8.2',
          text: 'Категорически запрещено выкладывать, распространять или использовать читы, эксплойты и вредоносные файлы.'
        },
        {
          number: '',
          text: 'Наказание за нарушения Разделов 6, 7 и 8: Мут на 6 часов / Бан (в зависимости от тяжести). Повторное нарушение — мут на 24 часа / перманентный бан.'
        }
      ]
    },
    {
      id: 9,
      title: '9. Роли и права модерации',
      items: [
        {
          number: '9.1',
          text: 'Членам администрации и модерации запрещено злоупотреблять своими правами (удалять сообщения или наказывать игроков без объективной причины).'
        },
        {
          number: '9.2',
          text: 'Обращения игроков к персоналу должны быть вежливыми и конструктивными, без оскорблений и провокаций.'
        },
        {
          number: '',
          text: 'Наказание: Мут на 6 часов. Повторное нарушение — мут на 24 часа с последующим снятием полномочий (для персонала) или перманентным баном (для игроков).'
        }
      ]
    },
    {
      id: 10,
      title: '10. Игровые взаимодействия и геймплей',
      items: [
        {
          number: '10.1',
          text: 'Категорически запрещено использование стороннего ПО (читов) для получения игрового преимущества.'
        },
        {
          number: '',
          text: 'Наказание: Перманентный бан (согласно п. 11.4).'
        },
        {
          number: '10.2',
          text: 'Запрещено использование недоработок игры (багоюз) и эксплойтов.'
        },
        {
          number: '10.3',
          text: 'Запрещен намеренный грифинг: разрушение чужих построек, создание ловушек без возможности выхода, кража ресурсов без согласия владельца.'
        },
        {
          number: '10.4',
          text: 'Запрещен систематический PvP-таргетинг и сталкинг (намеренное преследование конкретного игрока), а также кемперство (длительное ожидание у точек возрождения, выходов из безопасных зон или границ привата для мгновенного убийства).'
        },
        {
          number: '10.5',
          text: 'Запрещен обман игроков при обмене предметами или оказании внутриигровых услуг.'
        },
        {
          number: '10.6',
          text: 'Запрещено использование автокликеров и макросов для автоматизации процессов, влияющих на игровой баланс.'
        },
        {
          number: '10.7',
          text: 'Запрещено искусственное создание большого количества сущностей (мобов), вызывающее нагрузку на сервер, а также использование боссов в качестве бесконечного спавнера.'
        },
        {
          number: '',
          text: 'Наказание за п. 10.2 — 10.7: 2 варна. Повторное нарушение — бан на 48 часов с последующим перманентным баном. За грубый сталкинг срок бана может быть увеличен.'
        },
        {
          number: '10.8',
          text: 'Категорически запрещена купля, продажа или обмен любых внутриигровых ценностей (предметов, валюты, аккаунтов, кланов, приватов) за реальные деньги вне официального магазина сервера (РМТ).'
        },
        {
          number: '',
          text: 'Наказание: Перманентный бан продавца и покупателя без права обжалования.'
        }
      ]
    },
    {
      id: 11,
      title: '11. Санкции за нарушения и их применение',
      items: [
        {
          number: '11.1',
          text: 'Предупреждение (Warn): Применяется при легких нарушениях. Накладывается на нефиксированный срок. 3 активных варна автоматически приводят к блокировке на сутки.'
        },
        {
          number: '11.2',
          text: 'Мьют (Mute): Временное ограничение текстового или голосового чата на срок от 1 часа до 7 дней.'
        },
        {
          number: '11.3',
          text: 'Бан (Ban): Временная или перманентная блокировка доступа к серверу. Если вы считаете блокировку ошибочной, вы можете подать тикет на обжалование немедленно. В случае явного нарушения правил подача прошения об амнистии (помиловании) возможна не ранее, чем через 14 дней.'
        },
        {
          number: '11.4',
          text: 'Перманентный бан без права обжалования: Применяется за деструктивные действия (читы, РМТ, выдача себя за администрацию с целью мошенничества, распространение вредоносного ПО, критические эксплойты).'
        },
        {
          number: '11.5',
          text: 'Любое имущество или валюта, полученные нечестным путем, изымаются без права на компенсацию.'
        },
        {
          number: '11.6',
          text: 'Запрещено публичное обсуждение выданных наказаний в общих чатах. Все споры ведутся строго через тикеты поддержки.'
        },
        {
          number: '11.7',
          text: 'Создание альтернативных аккаунтов (мультиаккаунтинг) для обхода бана карается перманентным баном всех аккаунтов.'
        }
      ]
    },
    {
      id: 12,
      title: '12. Обращение к администрации и техподдержка',
      items: [
        {
          number: '12.1',
          text: 'По всем вопросам касательно правил, багов, жалоб или обжалования наказаний необходимо обращаться строго через официальные каналы связи службы поддержки проекта.'
        },
        {
          number: '12.2',
          text: 'При подаче жалобы игрок обязан предоставить прямые доказательства нарушения (скриншоты, видео, логи).'
        },
        {
          number: '12.3',
          text: 'Решения администрации являются окончательными. Обжалования и амнистии происходят только в индивидуальном порядке.'
        },
        {
          number: '12.4',
          text: 'Администрация оставляет за собой право удалять деструктивные сообщения, банить или исключать участников без объяснения причин, если это необходимо для поддержания порядка на сервере.'
        }
      ]
    }
  ];

  return (
    <main className={`container ${styles.serverRules}`}>
      <div className="container">
        <div style={{marginTop: '1rem'}}>
          <header className={styles.header}>
            <h1 className="title">Правила сервера</h1>
            <p className={styles.subtitle}>Свод правил сервера Interworld</p>
            <p className={styles.intro}>
              Добро пожаловать на наш проект! Чтобы игра и общение приносили удовольствие всем участникам, у нас действуют правила. Рекомендуем внимательно ознакомиться с ними.
            </p>
          </header>

          <div className={styles.sectionsContainer}>
            {sections.map((section) => (
              <div key={section.id} className={`glassCard ${styles.section}`}>
                <h2 className={styles.sectionTitle}>{section.title}</h2>
                <div className={styles.itemsList}>
                  {section.items.map((item, index) => (
                    <div key={index} className={styles.item}>
                      {item.number && (
                        <span className={styles.itemNumber}>{item.number}</span>
                      )}
                      <p className={styles.itemText}>{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className={styles.footer}>
            <p className={styles.updateDate}>Дата последнего обновления: 21 июля 2026 г.</p>
          </div>

          <div className={styles.contactsSection}>
            <Contacts />
          </div>

        </div>
      </div>
    </main>
  );
};

export default ServerRules;
